function fixTolstoyThumbnailsAccessibility() {
  document.querySelectorAll('img.tolstoy-tile-image').forEach(function(img, i) {
    if (!img.hasAttribute('alt') || img.alt === '') {
      img.alt = 'Video thumbnail ' + (i + 1)
    }
  });
}

document.addEventListener('DOMContentLoaded', fixTolstoyThumbnailsAccessibility);
document.addEventListener('page:loaded', fixTolstoyThumbnailsAccessibility);

const tolstoyObserver = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.addedNodes.length) {
      fixTolstoyThumbnailsAccessibility();
    }
  }
});
tolstoyObserver.observe(document.body, { childList: true, subtree: true });

let pollCount = 0;
const pollInterval = setInterval(() => {
  fixTolstoyThumbnailsAccessibility();
  pollCount++;
  if (pollCount > 10) clearInterval(pollInterval);
}, 1000);

function fixTolstoyButtonRoles() {
  document.querySelectorAll('button.tolstoy-tile-play-button-container[role="button"]').forEach(function(btn) {
    btn.removeAttribute('role');
  });
}

document.addEventListener('DOMContentLoaded', fixTolstoyButtonRoles);
document.addEventListener('page:loaded', fixTolstoyButtonRoles);

const tolstoyButtonObserver = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.addedNodes.length) {
      fixTolstoyButtonRoles();
    }
  }
});
tolstoyButtonObserver.observe(document.body, { childList: true, subtree: true });

let tolstoyButtonPollCount = 0;
const tolstoyButtonPollInterval = setInterval(() => {
  fixTolstoyButtonRoles();
  tolstoyButtonPollCount++;
  if (tolstoyButtonPollCount > 10) clearInterval(tolstoyButtonPollInterval);
}, 1000); 